var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-AboutUs backdrop",attrs:{"id":"main-AboutUs"}},[_c('div',{staticClass:"introduce"},[_c('ul',_vm._l((_vm.$t('img')),function(obj){return _c('li',[_c('img',{attrs:{"src":obj.src}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(obj.name))])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ddb670c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/us_environment.vue
// module id = null
// module chunks = 